import { useMutation, useQueryClient } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { LOADING_FLIGHT, LOADING_TOTALS } from '../../consts/flights.js';

export const useCreateFlightsApi = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      activityId,
      type,
    }: {
      activityId: string;
      type: 'custom';
    }) => {
      return MediaPlan.createFlights({
        data: { activityId, type },
      });
    },
    onMutate: async ({ activityId }) => {
      const queryKey = MediaPlan.getFlightsListQueryOptions({
        params: { activityId },
      }).queryKey;

      await queryClient.cancelQueries({
        queryKey,
      });

      const previousFlights =
        queryClient.getQueryData<MediaPlan.FlightsList>(queryKey);

      queryClient.setQueryData<MediaPlan.FlightsList>(
        queryKey,
        (oldFlights?: MediaPlan.FlightsList) => {
          if (!oldFlights?.data) {
            return;
          }

          return {
            ...oldFlights,
            data: {
              ...oldFlights.data,
              items: [...oldFlights.data.items, LOADING_FLIGHT],
              additional: {
                ...oldFlights.data.additional,
                totals: LOADING_TOTALS,
                customFlightCanBeCreated: true,
                isLastFlightDeletable: false,
              },
            },
          };
        },
      );

      return { previousFlights };
    },
    onError: (_, { activityId }, context) => {
      queryClient.setQueryData<MediaPlan.FlightsList>(
        MediaPlan.getFlightsListQueryOptions({
          params: { activityId },
        }).queryKey,
        context?.previousFlights,
      );
    },

    onSettled: (_, __, { activityId }) => {
      queryClient.invalidateQueries(
        MediaPlan.getFlightsListQueryOptions({
          params: { activityId },
        }),
      );
    },
  });
};
